import { FormField } from "../../components/FormElements/FormFieldsRenderer";

const registerPatient = (t, requiredFields, regionProps, pharmacyProps) => {
  const patientFormDefinitions = [
    {
      key: 'firstName'
    },
    {
      key: 'lastName'
    },
    {
      key: 'email'
    },
    {
      key: 'password',
      type: 'password'
    },
    {
      key: 'idNumber'
    },
    {
      key: 'address'
    }
  ];

  const formFields: FormField[] = patientFormDefinitions.map(field => {
    const { key, type } = field;

    return {
      label: t(`common.registrationForm.${key}`),
      prefix: 'patientProfile',
      isRequired: requiredFields[key],
      fieldType: 'Text',
      isFullWidth: true,
      subType: type || 'text',
      name: key,
      isDisabled: field.key === 'email'
    };
  });

  formFields.push(
    {
      label: t(`regionSelector.county`),
      prefix: 'patientProfile',
      isRequired: true,
      regionProps: regionProps,
      name: 'region',
      fieldType: 'Region'
    },
    {
      label: t(`common.registrationForm.phone`),
      prefix: 'patientProfile',
      isRequired: requiredFields.phone,
      fieldType: 'Text',
      isFullWidth: true,
      subType: 'text',
      name: 'phone'
    },
    {
      label: t(`common.registrationForm.preferredPharmacy`),
      prefix: 'patientProfile',
      isRequired: requiredFields.pharmacy,
      fieldType: 'Pharmacy',
      isFullWidth: true,
      name: 'pharmacyId',
      pharmacyProps: pharmacyProps
    },
    {
      label: t('common.registrationForm.activationCode'),
      fieldType: 'Text',
      prefix: 'doctorProfile',
      isRequired: requiredFields.activationCode,
      isFullWidth: true,
      subType: 'text',
      name: 'activationCode'
    },
    {
      label: t('common.registrationForm.terms'),
      fieldType: 'Terms',
      prefix: 'patientProfile',
      isRequired: requiredFields.termsAndConditions,
      isFullWidth: true,
      subType: 'text',
      name: 'terms'
    }
  );

  return formFields;
}

export default registerPatient;
